import {
  groupExternalScenarios,
  type ExternalScenario,
  type ExternalScenarioStep,
  type ExternalStepVerdict,
} from '@chatsdet/test-reporters/browser';
import type { ExternalTestProvider } from '@chatsdet/types';
import type { ExternalRunItemDto } from './useExternalRun';

export type StepVerdict = ExternalStepVerdict;
export type ScenarioStep = ExternalScenarioStep<ExternalRunItemDto>;
export type Scenario = ExternalScenario<ExternalRunItemDto>;

/** Web compatibility wrapper around the shared API/CLI scenario fold. */
export function groupScenarios(
  items: ExternalRunItemDto[],
  provider: ExternalTestProvider
): Scenario[] {
  return groupExternalScenarios(items, provider);
}
